<hotkeys-cheatsheet [title]="null"></hotkeys-cheatsheet>

<app-loading [busy]="loadingBusy$ | async" [text]="loadingText$ | async"></app-loading>

<router-outlet></router-outlet>
